export const CHART_HEIGHTS = {
  STANDARD: "400px",
  LARGE: "450px",
  SMALL: "300px",
};

export const CHART_COLORS = {
  PRIMARY: "#00A7A6",
  GRAY: "#d3d3d3",
  GRAY_LIGHT: "#9ca3af",
  TOOLTIP: "#f8AA00",
  BORDER: "#d3d3d3",
};
